import { useEffect, useState } from "react"; // Unificado o useState aqui
import {
  Box,
  TextField,
  Button,
  Grid,
  OutlinedInput,
  Typography, // Adicionado
  Avatar, // Adicionado
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  InputAdornment,
} from "@mui/material";

import { useNavigate, useParams } from "react-router-dom"; // Unificado react-router-dom
import { PutAPI } from "../../Components/Backend/PutAPI";
import { GetAPI } from "../../Components/Backend/GetAPI";
import { usePermiteAcesso } from "../../Components/Funcionais/Utils";
import PageTitle from "../../Components/Layout/PageTitle";
import PageSubTitle from "../../Components/Layout/PageSubTitle";
import APIAxios from "../../Api/APIAxios";

// Ícones
import ListIcon from "@mui/icons-material/List";
import AttachFileIcon from "@mui/icons-material/AttachFile"; // Adicionado

const ColaboradorAlterar = () => {
  //***************************************   AVISOS E LOADING ************************************************* */
  // CONTROLE DE AVISOS E ALERTAS
  //Funcão para fechar avisos e alertas
  usePermiteAcesso(4); //Colaboradores
  const [avisoErro, setAvisoErro] = useState("");
  const [avisoSucesso, setAvisoSucesso] = useState("");
  const [loading, setLoading] = useState(false);
  //************************************************************************************************** */

  const navigate = useNavigate();
  const apiAxios = APIAxios();
  const { id } = useParams();

  const [grupos, setGrupos] = useState([]);
  const [gruposSelecionados, setGruposSelecionados] = useState([]);
  const [jornadasSelecionadas, setJornadasSelecionadas] = useState("");
  const [jornadas, setJornadas] = useState([]);
  const MAX_SIZE = 2 * 1024 * 1024; // 2MB

  const [formData, setFormData] = useState({
    id: 0,
    nome: "",
    cargo: "",
    idEmpresa: 0,
    idGrupo: 0,
    idCalendario: 0,
    espacoUtilizado: "",
    primeiroRegistro: "",
    primeiraImagem: "",
    avatarUrl: "",
  });

  // Função para formatar bytes em KB, MB ou GB
  const formatarBytes = (bytes) => {
    if (bytes >= 1024 ** 3) return `${(bytes / 1024 ** 3).toFixed(2)} GB`;
    if (bytes >= 1024 ** 2) return `${(bytes / 1024 ** 2).toFixed(2)} MB`;
    return `${(bytes / 1024).toFixed(2)} KB`;
  };

  const formatarUsoEspaco = (usado, total) => {
    const percentual = ((usado / total) * 100).toFixed(2);
    return `${formatarBytes(usado)}`;
  };

  //Busca Grupos no backend
  const buscaGrupos = async () => {
    const response = await GetAPI(apiAxios, "/grupos");

    if (response.success) {
      setGrupos(response.data);
    } else {
      setAvisoErro(response.errorMessage || "Erro ao carregar grupos.");
    }
  };

  //Busca Colaboradores no backend
  const buscaColab = async () => {
    const response = await GetAPI(apiAxios, `/colab/${id}`);

    if (response.success) {
      setFormData(response.data);
      setGruposSelecionados(response.data.idGrupo);
      setJornadasSelecionadas(response.data.idCalendario || "");
      carregarAvatar(response.data.id);
    } else {
      setAvisoErro(response.errorMessage || "Erro ao carregar grupos.");
    }
  };

  const carregarAvatar = async (id) => {
    //Carrega identificação das imagens
    const response = await GetAPI(apiAxios, "/colab/avatar/" + id, {
      responseType: "blob",
    });

    // Cria uma URL temporária para o blob recebido
    const blobUrl = URL.createObjectURL(response.data);

    setFormData((prev) => ({
      ...prev,
      avatarUrl: blobUrl,
    }));
  };

  //Busca Jornadas no backend
  const buscaJornadas = async () => {
    const response = await GetAPI(apiAxios, "/calendarios");

    if (response.success) {
      setJornadas(response.data);
    } else {
      setAvisoErro(response.errorMessage || "Erro ao carregar grupos.");
    }
  };

  const handleVoltar = () => {
    navigate("/colaboradores");
  };

  // Se o valor do campo for uma string, converte para maiúsculas
  const handleChange = (event, tam) => {
    const { name, value } = event.target;

    let valor = value;

    //Limita tamanho do campo
    if (typeof value === "string") {
      valor = valor.slice(0, tam);
    }

    setFormData((prevData) => ({
      ...prevData,
      [name]: typeof valor === "string" ? valor.toUpperCase() : valor,
    }));
  };

  // Recebe o clique no botao SALVAR ou no SALVAR + INCLUIR
  // Se for SALVAR + INCLUIR, chama a função limparCampos para limpar os campos do formulário
  const handleSubmit = async (event) => {
    event.preventDefault();

    const registro = {
      id: formData.id,
      nome: formData.nome.trim(),
      cargo: formData.cargo.trim(),
      idEmpresa: formData.idEmpresa,
      idGrupo: gruposSelecionados,
      idCalendario: jornadasSelecionadas,
      espacoUtilizado: formData.espacoUtilizado,
    };

    setLoading(true);
    const response = await PutAPI(apiAxios, "/colab", registro);

    setLoading(false);

    if (response.success) {
      setFormData((prev) => ({
        ...prev,
        ...response.data,
        espacoUtilizado: prev.espacoUtilizado, // garante que não zera
      }));

      //Exibe mensagem de sucesso por 5 segundos e limpa a tela
      setAvisoSucesso("Perfil de colaborador incluído com sucesso!");
    } else {
      setAvisoErro(response.errorMessage || "Erro ao atualizar colaborador.");
    }
  };

  const uploadAvatar = async (file) => {
    const fd = new FormData();
    fd.append("file", file);

    const resp = await apiAxios.post(`/colab/avatar/${formData.id}`, fd, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    return resp.data;
  };

  // Função para processar a nova imagem selecionada
  const handleImageChange = async (e) => {
    setAvisoErro("");
    setAvisoSucesso("");
    setLoading(true);

    const file = e.target.files?.[0];
    if (!file) return;

    //permite escolher o mesmo arquivo novamente
    e.target.value = "";

    // valida tamanho
    if (file.size > MAX_SIZE) {
      setAvisoErro("Imagem maior que 2MB.");
      return;
    }

    // valida extensão (backend aceita apenas .png ou .jpg)
    const ext = file.name.split(".").pop()?.toLowerCase();
    const allowedExt = ["png", "jpg"];
    if (!ext || !allowedExt.includes(ext)) {
      setAvisoErro("Arquivo deve ser PNG ou JPG.");
      return;
    }

    // valida mime-type (mais confiável que só extensão)
    const allowedMime = ["image/png", "image/jpeg"];
    if (!allowedMime.includes(file.type)) {
      setAvisoErro("Tipo de arquivo inválido. Use PNG ou JPG.");
      return;
    }

    // preview local imediato
    const previewUrl = URL.createObjectURL(file);
    setFormData((prev) => ({ ...prev, avatarUrl: previewUrl }));

    try {
      setLoading(true);
      setAvisoErro("");
      setAvisoSucesso("");

      await uploadAvatar(file);

      // Recarrega do backend (opcional, mas garante que está pegando o arquivo salvo)
      await carregarAvatar(formData.id);

      setAvisoSucesso("Avatar atualizado com sucesso!");
    } catch (err) {
      setAvisoErro("Falha ao enviar avatar.");
    } finally {
      setLoading(false);

      // limpa URL temporária do preview (evita vazamento de memória)
      URL.revokeObjectURL(previewUrl);
    }
  };

  const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

  const carregarDados = async () => {
    try {
      setLoading(true);

      await Promise.all([
        Promise.all([buscaColab(), buscaGrupos(), buscaJornadas()]),
        sleep(1000), // tempo mínimo de loading
      ]);
    } catch (err) {
      setAvisoErro("Erro ao carregar dados.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    carregarDados();
  }, []);

  return (
    <div>
      {/******************************* TITULO E FUNCIONALIDADES *************************/}
      <PageTitle
        caption="Alterar Colaboradores"
        setAvisoErro={setAvisoErro}
        avisoErro={avisoErro}
        avisoSucesso={avisoSucesso}
        setAvisoSucesso={setAvisoSucesso}
        loading={loading}
        accentStyle
      />
      {/**********************************************************************************/}
      <Box sx={{ flexGrow: 1, padding: 3 }}>
        <form onSubmit={handleSubmit}>
          <Grid container spacing={4}>
            {/* SEÇÃO DA ESQUERDA: AVATAR */}
            <Grid
              item
              xs={12}
              md={3}
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                borderRight: { md: "1px solid #e0e0e0" },
                pr: { md: 4 },
              }}
            >
              <Avatar
                src={formData.avatarUrl}
                sx={{ width: 160, height: 160, mb: 2, bgcolor: "#f5f5f5" }}
              />

              <Button
                component="label"
                variant="outlined"
                startIcon={<AttachFileIcon />}
                sx={{
                  mb: 1,
                  textTransform: "none",
                  width: "100%",
                  borderColor: "#1a3865",
                  color: "#1a3865",
                }}
              >
                Atualizar imagem
                <input
                  type="file"
                  hidden
                  accept="image/png,image/jpeg"
                  onChange={handleImageChange}
                />
              </Button>

              <Typography variant="caption" color="textSecondary">
                PNG/JPG - até 2MB
              </Typography>
            </Grid>

            {/* SEÇÃO DA DIREITA: SEU FORMULÁRIO ATUAL */}
            <Grid item xs={12} md={9}>
              <Grid container spacing={2}>
                {/* Nome */}
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="Nome:"
                    variant="outlined"
                    value={formData.nome}
                    onChange={(e) => handleChange(e, 50)}
                    required
                    name="nome"
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <ListIcon />
                        </InputAdornment>
                      ),
                    }}
                  />
                </Grid>

                {/* Cargo */}
                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    label="Cargo:"
                    variant="outlined"
                    value={formData.cargo}
                    onChange={(e) => handleChange(e, 100)}
                    required
                    name="cargo"
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <ListIcon />
                        </InputAdornment>
                      ),
                    }}
                  />
                </Grid>

                {/* Select de Grupos */}
                <Grid item xs={12} md={6}>
                  <FormControl fullWidth>
                    <InputLabel id="label-grupos">Grupo</InputLabel>
                    <Select
                      labelId="label-grupos"
                      value={gruposSelecionados}
                      onChange={(e) =>
                        setGruposSelecionados(Number(e.target.value))
                      }
                      input={<OutlinedInput label="Grupos" />}
                    >
                      {(grupos ?? []).map((group) => (
                        <MenuItem key={group.id} value={String(group.id)}>
                          {group.nome}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>

                {/* Select de Jornadas */}
                <Grid item xs={12} md={12}>
                  <FormControl fullWidth>
                    <InputLabel id="label-jornadas">Jornada</InputLabel>
                    <Select
                      labelId="label-jornadas"
                      value={jornadasSelecionadas}
                      onChange={(e) =>
                        setJornadasSelecionadas(Number(e.target.value))
                      }
                      input={<OutlinedInput label="Jornadas" />}
                    >
                      {(jornadas ?? []).map((journey) => (
                        <MenuItem key={journey.id} value={String(journey.id)}>
                          {journey.descricao}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>

                {/* --- RODAPÉ: BOTÕES --- */}
                <Grid
                  item
                  xs={12}
                  sx={{ mt: 4, pt: 2, borderTop: "1px solid #eee" }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: { xs: "column", md: "row" },
                      justifyContent: "space-between",
                      alignItems: "center",
                      gap: { xs: 3, md: 2 },
                    }}
                  >
                    <Button
                      variant="contained"
                      sx={{
                        backgroundColor: "#1a3865",
                        px: 4,
                        // Ocupa 100% no mobile para seguir o padrão visual
                        width: { xs: "100%", md: "auto" },
                      }}
                      onClick={handleVoltar}
                    >
                      VOLTAR
                    </Button>

                    <Button
                      variant="contained"
                      type="submit"
                      sx={{
                        backgroundColor: "#1a3865",
                        px: 4,
                        width: { xs: "100%", md: "auto" },
                      }}
                    >
                      SALVAR
                    </Button>
                  </Box>
                </Grid>

                {/* Informações de Armazenamento */}
                <Grid item xs={12}>
                  <PageSubTitle caption="Informações de Armazenamento" />
                </Grid>

                <Grid item xs={12} md={4}>
                  <TextField
                    fullWidth
                    label="Espaço Utilizado:"
                    disabled
                    value={formatarUsoEspaco(formData.espacoUtilizado)}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <ListIcon />
                        </InputAdornment>
                      ),
                    }}
                  />
                </Grid>

                <Grid item xs={12} md={4}>
                  <TextField
                    fullWidth
                    label="Registro Mais Antigo de Atividade"
                    disabled
                    value={formData.primeiroRegistro ?? ""}
                    InputLabelProps={{ shrink: true }}
                  />
                </Grid>

                <Grid item xs={12} md={4}>
                  <TextField
                    fullWidth
                    label="Registro Mais Antigo de Imagem"
                    disabled
                    value={formData.primeiraImagem ?? ""}
                    InputLabelProps={{ shrink: true }}
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </form>
      </Box>
    </div>
  );
};

export default ColaboradorAlterar;
